export const trackingCode = 'UA-155775162-1';
